import { Icon, IconsEnum } from 'components/Icons';

import { RideStatus } from 'features/ippica/types';
import { memo } from 'react';
import styles from './IppicaLegendaItem.module.scss';
import { useIsDarkTheme } from 'hooks/useIsDarkTheme';

export type IppicaLegendaItemProps = {
  type: RideStatus;
  label: string;
  containerClassName?: string;
};

export const IppicaLegendaItem = memo(function IppicaLegendaItem({
  type,
  label,
  containerClassName,
}: IppicaLegendaItemProps) {
  const { isDarkMode } = useIsDarkTheme();

  return (
    <div
      className={`${styles.container} ${styles[`container${type}`]} ${containerClassName ? containerClassName : ''}`}
    >
      <Icon
        iconId={
          IconsEnum[
            `LEGENDA_${type.toUpperCase().replace('-', '')}_${isDarkMode ? 'DARK' : 'LIGHT'}` as keyof typeof IconsEnum
          ]
        }
        className={`${styles.icon} ${styles[`icon${type}`]}`}
      />
      <span className={styles.text}>{label}</span>
    </div>
  );
});
